export default "__VITE_ASSET__BW$MDZCl__"